import * as React from 'react';

export interface CarouselNames {
  topCarousel?: string;
}
export interface CarouselContextProviderState {
  carouselNames: CarouselNames;
  addTopCarouselName: (carouselId: string) => void;
}

const CarouselContext = React.createContext<CarouselContextProviderState>({
  carouselNames: {},
  addTopCarouselName: () => {},
});

export const CarouselProvider: React.FC = ({ children }) => {
  const [carouselNames, setCarouselNames] = React.useState({});

  const addTopCarouselName = (carouselId: string) => {
    setCarouselNames({
      topCarousel: carouselId,
    });
  };

  return (
    <CarouselContext.Provider
      value={{
        carouselNames,
        addTopCarouselName,
      }}
    >
      {children}
    </CarouselContext.Provider>
  );
};

export default CarouselContext;
